<!--
 * @Author: klein
 * @Date: 2021-09-28 14:51:55
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2022-01-10 14:29:39
 * @FilePath: \planApp\src\views\Home.vue
-->
<template>
  <div class="home-content">
    <div class="container">
      <el-dialog
        :title="ProductTitle"
        :visible.sync="ProductVisible"
        width="fit-content"
        top="0vh"
        id="view-dialog"
        custom-class="view-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
        :modal="false"
        v-draggable="draggabledFn"
      >
        <template slot="title"> </template>
        <template v-if="false">
          <HeaderContent />
          <Tabs />
        </template>
        <template v-if="product == '12Tvuchannel'">
          <Channel @titlechange="titlechange" />
        </template>
        <template v-if="product == 'Tvusearch'">
          <Search @titlechange="titlechange" />
        </template>
        <template v-if="product == 'Payment'">
          <Payment @titlechange="titlechange" />
        </template>
        <template v-if="product == 'old_Producer'">
          <Producer @titlechange="titlechange" />
        </template>
        <template v-if="product == 'Mediahub' || product == 'Tvuchannel' || product == 'Producer'">
          <Mediahub @titlechange="titlechange"></Mediahub>
        </template>
        <template v-if="product == 'Micro'">
          <Micro @titlechange="titlechange"></Micro>
        </template>
      </el-dialog>
      <div id="billing-suberr">
        <el-dialog
          :title="Dialogtitle"
          :visible.sync="DialogVisible"
          width="408px"
          custom-class="billing-dialog"
          :before-close="() => handleDialog(false)"
          :append-to-body="true"
        >
          <div class="sub-content">
            <i class="el-icon-warning-outline sub-icon"></i>
            <div class="failed-text">SUBSCRIPTION FAILED</div>
            <div class="failed-info">{{ Dialogmessage }}</div>
          </div>
          <span
            slot="footer"
            class="dialog-footer">
            <el-button
              class="cancel"
              @click="handleDialog(false)">Cancel</el-button>
            <el-button
              type="primary"
              @click="handleDialog(true)"
            >Go Now</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '../components/Tabs'
import HeaderContent from '../components/HeaderContent.vue'
import Channel from '../components/Channel/index.vue'
import Search from '../components/Search/Search.vue'
import Payment from '../components/Payment/Payment.vue'
import Producer from '../components/Producer/index.vue'
import Mediahub from '../components/MediaHub/Index.vue'
import Micro from '../components/Micro/Index.vue'
import { mapState } from 'vuex'
export default {
  name: 'Home',
  components: {
    Tabs,
    HeaderContent,
    Channel,
    Search,
    Payment,
    Producer,
    Mediahub,
    Micro
  },
  data () {
    return {
      activeName: 'first',
      isPartyline: false,
      isManage: true,
      ProductVisible: false,
      DialogVisible: false,
      Dialogtitle: '',
      Dialogmessage: '',
      ProductTitle: '',
      OriginTitle: ''
    }
  },
  methods: {
    titlechange (value) {
      if (this.product == 'Mediahub' || this.product == 'Tvuchannel' || this.product == 'Producer') {
        this.ProductTitle = value ? this.$t('mediahub.' + value) : value
        this.OriginTitle = value
      } else {
        this.ProductTitle = value
      }
    },
    draggabledFn () {},
    // 点击关闭
    handleClose () {
      this.$store.commit('handleIframeData', null)
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
    },
    handleDialog (flag) {
      console.log(flag, this.iframeData)
      this.DialogVisible = false
      const data = {
        key: this.iframeData.key,
        value: flag ? 'confirm' : 'cancel'
      }
      const params = {
        type: 'Dialog',
        from: 'billing',
        data
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    }
  },
  mounted () {
    // this.$store.commit('handleIframeData', {
    //   product: 'Mediahub',
    //   result: {
    //     objectId: 'fednetobjectid',
    //     slugName: '010324-1100: House pro forma session - Second Session, 118th Congress',
    //     slugDate: '2024/1/3 23:55 - 2024/1/4 00:56',
    //     gridName: 'FedNet_2',
    //     planId: 'mm_fednet_sub_98',
    //     payType: 1,
    //     exportFilename: '010324-1100 House p_wGxX',
    //     duration: 54,
    //     type: 'takelive',
    //     nodeType: 'cloud'
    //   }
    // })
  },
  watch: {
    product () {
      this.Dialogtitle = ''
      this.ProductTitle = ''
      if (this.product === 'Dialog') {
        const { title, message } = this.iframeData
        this.Dialogtitle = `Subscribe to ${title} Service`
        this.Dialogmessage = message
        this.ProductVisible = false
        this.DialogVisible = true
      } else {
        this.ProductVisible = true
        this.DialogVisible = false
      }

      console.log(this.product)
    },
    '$i18n.locale' () {
      this.ProductTitle = this.$t('mediahub.' + this.OriginTitle)
    }
  },
  computed: {
    ...mapState({
      product: 'product',
      iframeData: 'iframeData'
    })
  }
}
</script>

<style lang="less" scoped>
.home-content {
  height: calc(100vh - 40px);
}
.container {
  width: 1140px;
}
@media screen and (max-width: 840px) {
  .container {
    width: auto;
    height: 100%;
    margin: 0 10px;
  }
}
::v-deep .view-dialog > .el-dialog__header {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: #252525;
  padding: 20px 0 10px;
  margin: 0 20px;
  border-bottom: 2px solid #ddd;
  .el-dialog__title {
    height: 24px;
    display: block;
  }
}
::v-deep .view-dialog {
  margin: 0px;
  border-radius: 15px;
  .el-dialog__header {
    //   text-align: left;
    //   font-weight: 700;
    //   font-size: 16px;
    //   line-height: 18px;
    //   color: #252525;
    //   padding: 20px 0 10px;
    //   margin: 0 20px;
    //   border-bottom: 2px solid #ddd;
  }
  .el-dialog__body {
    // padding: 0;
  }
}

::v-deep .billing-dialog {
  height: 500px;
  border-radius: 15px;
  .el-dialog__body {
    height: 300px;
  }
  .el-dialog__header {
    font-weight: 800;
    padding: 20px 0 10px;
    margin: 0 20px;
    border-bottom: 2px solid #ddd;
  }
  .el-dialog__footer {
    .el-button--primary {
      background: #33ab4f;
      color: #252525;
      border-color: #33ab4f;
    }
  }
  .sub-content {
    text-align: center;
    margin-top: 30px;
    .sub-icon {
      font-size: 84px;
      color: #ec5050;
    }
    .failed-text {
      font-size: 16px;
      font-weight: 700;
      margin: 15px 0;
      color:#DBDBDB;
    }
    .failed-info {
      margin: 0 auto;
      width: 280px;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #979797;
      word-break: break-word;
    }
  }
  .dialog-footer {
    .cancel.el-button {
      background-color: #252525;
      border-color: #666666;
      color: #DBDBDB;
    }
  }
}
</style>
